<template>
    <comp-9-art-adherence :section="9" :page="63" :nextDisabled="nextDisabled" :next="nextScreen">
        <p>
            Would you like to explore ways that may help you to take ART regularly?
        </p>
        <v-radio-group v-model="artRegularSupportSelection" column>
            <v-radio v-for="regularSupport in artRegularSupports" :key="regularSupport.id" :label="regularSupport.text" :value="regularSupport"></v-radio>
        </v-radio-group>
    </comp-9-art-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { find, forEach } from 'lodash';

export default {
    data: function() {
        return {
            artRegularSupportSelection: null
        };
    },
    computed: {
        artRegularSupport() {
            let selectedArtRegularSupport = find(this.artRegularSupports, 'selected');

            if (selectedArtRegularSupport) {
                return selectedArtRegularSupport;
            } else return null;
        },
        artRegularSupports: sync('section9/artRegularSupport'),
        nextScreen() {
            if (this.artRegularSupportSelection) {
                return `/page/9/${this.artRegularSupportSelection.nextScreen}`;
            }

            return null;
        }
    },
    methods: {
        nextDisabled() {
            return !this.artRegularSupportSelection;
        }
    },
    watch: {
        artRegularSupportSelection(newArtRegularSupportSelection) {
            forEach(this.artRegularSupports, o => {
                if (o.id === newArtRegularSupportSelection.id) {
                    o.selected = true;
                } else {
                    o.selected = false;
                }
            });
        }
    },
    mounted() {
        this.artRegularSupportSelection = this.artRegularSupport;
    }
};
</script>
